import { useTheme } from "@/components/theme/use-theme";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme, theme } = useTheme();
  const activeTheme = theme === "system" ? resolvedTheme : theme;

  return (
    <Sonner
      theme={activeTheme as ToasterProps["theme"]}
      className="quire-toaster"
      toastOptions={{
        unstyled: true,
      }}
      {...props}
    />
  );
};

export { Toaster };
